var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRareDiseaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0953 16.256C14.3932 16.256 16.256 14.3932 16.256 12.0953C16.256 9.79739 14.3932 7.93457 12.0953 7.93457C9.79739 7.93457 7.93457 9.79739 7.93457 12.0953C7.93457 14.3932 9.79739 16.256 12.0953 16.256Z",
    fill: "#5A52C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32148 5.99294C10.0875 5.99294 10.7084 5.372 10.7084 4.60603C10.7084 3.84006 10.0875 3.21912 9.32148 3.21912C8.55551 3.21912 7.93457 3.84006 7.93457 4.60603C7.93457 5.372 8.55551 5.99294 9.32148 5.99294Z",
    fill: "#5A52C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9143 15.1464C23.6802 15.1464 24.3012 14.5255 24.3012 13.7595C24.3012 12.9936 23.6802 12.3726 22.9143 12.3726C22.1483 12.3726 21.5273 12.9936 21.5273 13.7595C21.5273 14.5255 22.1483 15.1464 22.9143 15.1464Z",
    fill: "#5A52C3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54804 19.5846C7.31401 19.5846 7.93495 18.9636 7.93495 18.1976C7.93495 17.4317 7.31401 16.8107 6.54804 16.8107C5.78207 16.8107 5.16113 17.4317 5.16113 18.1976C5.16113 18.9636 5.78207 19.5846 6.54804 19.5846Z",
    fill: "#5A52C3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0953 23.1906C18.223 23.1906 23.1906 18.223 23.1906 12.0953C23.1906 5.96753 18.223 1 12.0953 1C5.96753 1 1 5.96753 1 12.0953C1 18.223 5.96753 23.1906 12.0953 23.1906Z",
    stroke: "#5A52C3",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0949 20.4167C16.6907 20.4167 20.4164 16.6911 20.4164 12.0953C20.4164 7.49945 16.6907 3.7738 12.0949 3.7738C7.49908 3.7738 3.77344 7.49945 3.77344 12.0953C3.77344 16.6911 7.49908 20.4167 12.0949 20.4167Z",
    stroke: "#5A52C3",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRareDiseaseIcon);
export default __webpack_public_path__ + "static/media/rareDiseaseIcon.da9231fade6968d991f71b6e346b9397.svg";
export { ForwardRef as ReactComponent };